export class Session {
  userId: number;
  name: string;
  networkUsername: string;
  username: string;
  permissions: any[] = [];
  countryList: any[] = [];
  organizationList: any[] = [];
  organizationId: number;
  organizationName: string;
  securityRoleId: number;
  isClientRole: string;
  needsToChangePassword: string;
  securityRoleName: string;
  authToken: string;
  expireAt: Date;
  generateBenchTemplate: boolean;
  shippingMethodRequired: boolean;
  showHdrInfo: boolean;

  constructor() { }

}
